import React from 'react';
import { IconBase, IconBaseProps } from './IconBase';

export const Close: React.FunctionComponent<IconBaseProps> = (props) => (
  <IconBase {...props} viewBox="0 0 20 20">
    <polygon points="19.71 1.71 18.29 0.29 10 8.59 1.71 0.29 0.29 1.71 8.59 10 0.29 18.29 1.71 19.71 10 11.41 18.29 19.71 19.71 18.29 11.41 10 19.71 1.71" />
  </IconBase>
);
